// eslint-disable-next-line import/no-extraneous-dependencies
import { createLocalVue, shallowMount } from '@vue/test-utils'
import CoreFilePicker from 'src/core/CoreFilePicker/CoreFilePicker.vue'
import { getComponentConfig } from 'www/test/functions'
import { MIME_TYPES } from 'www/constants'

// eslint-disable-next-line import/no-extraneous-dependencies
jest.mock('heic2any', () => ({
  __esModule: true,
  default: jest.fn(),
}))
jest.mock('lodash/throttle', () => ({
  __esModule: true,
  default: jest.fn(callback => () => {
    callback()
  }),
}))

// eslint-disable-next-line import/no-extraneous-dependencies
jest.mock('src/core/CoreFilePicker/composables/useValidate', () => ({
  __esModule: true,
  default: jest.fn(() => ({
    validateFile: jest.fn(),
    validateImage: jest.fn(),
  })),
}))

// eslint-disable-next-line import/no-extraneous-dependencies
jest.mock('src/core/CoreFilePicker/composables/useHeic', () => ({
  __esModule: true,
  default: jest.fn(() => ({
    checkHeicNoSafariDesktop: jest.fn(),
  })),
}))

// eslint-disable-next-line import/no-extraneous-dependencies
jest.mock('src/core/CoreFilePicker/functions/readFileAsDataUrl', () => ({
  __esModule: true,
  default: jest.fn(),
}))

const localVue = createLocalVue()
// @ts-ignore
const mountComponent = (options: { propsData?: Record<string, any> } = {}) => shallowMount(CoreFilePicker, {
  localVue,
  ...getComponentConfig(options),
  propsData: options.propsData,
})

describe('CoreFilePicker', () => {
  beforeEach(() => {
    jest.clearAllMocks()
    window.MOBILE_VERSION = false
  })

  describe('Нажатие на Space, Enter или NumpadEnter', () => {
    let wrapper: ReturnType<typeof mountComponent>
    let label: ReturnType<typeof wrapper.find>

    beforeEach(() => {
      wrapper = mountComponent()
      label = wrapper.find('label')
    })

    test('Тогда при нажатии Space вызывается open', () => {
      label.trigger('keydown', { code: 'Space' })
      expect(wrapper.emitted('jest')?.map(i => i[0])).toContain('open')
    })

    test('Тогда при нажатии Enter вызывается open', () => {
      label.trigger('keydown', { code: 'Enter' })
      expect(wrapper.emitted('jest')?.map(i => i[0])).toContain('open')
    })

    test('Тогда при нажатии NumpadEnter вызывается open', () => {
      label.trigger('keydown', { code: 'NumpadEnter' })
      expect(wrapper.emitted('jest')?.map(i => i[0])).toContain('open')
    })

    test('Тогда при нажатии другой клавиши open не вызывается', () => {
      label.trigger('keydown', { code: 'Tab' })
      label.trigger('keydown', { code: 'Esc' })

      expect(wrapper.emitted('jest')).toBe(undefined)
    })
  })

  describe('Метод open', () => {
    test('Тогда в настольной версии сразу открывается выбор файла', () => {
      window.MOBILE_VERSION = false

      const wrapper = mountComponent()

      // @ts-ignore
      wrapper.vm.open()
      // @ts-ignore
      expect(wrapper.vm.jest.isOpenedCaptureTypeList.value).toBe(false)
      expect(wrapper.emitted('jest')?.map(i => i[0])).toContain('openFilePicker')
    })
    test('Тогда в мобильной версии сначала открывается выбор источника загрузки', () => {
      window.MOBILE_VERSION = true

      const wrapper = mountComponent()

      // @ts-ignore
      wrapper.vm.open()
      // @ts-ignore
      expect(wrapper.vm.jest.isOpenedCaptureTypeList.value).toBe(true)
      expect(wrapper.emitted('jest')?.map(i => i[0])).not.toContain('openFilePicker')
    })
  })

  describe('Свойство accept', () => {
    test('Тогда accept включает расширения из acceptFileTypes и .heic', () => {
      const wrapper = mountComponent({
        propsData: {
          acceptFileTypes: ['jpg', 'png'],
        },
      })

      // @ts-ignore
      expect(wrapper.vm.jest.accept.value).toContain('jpg')
      // @ts-ignore
      expect(wrapper.vm.jest.accept.value).toContain('png')
      // @ts-ignore
      expect(wrapper.vm.jest.accept.value).toContain('.heic')
    })

    test('Тогда accept содержит MIME_TYPES.all при пустых расширениях', () => {
      const wrapper = mountComponent()

      // @ts-ignore
      expect(wrapper.vm.jest.accept.value).toBe(MIME_TYPES.all)
    })
  })
})
